import useMutationApi from 'src/api/useMutationApi';

interface ApiResponse {
  success: boolean;
}

const useQueueUpApprovedPOEvent = (onSuccess?: () => void) => {
  return useMutationApi<void, ApiResponse>({
    endpoint: 'qa/queue-up-approved-po-event',
    method: 'POST',
    options: {
      onSuccess,
    },
  });
};

export default useQueueUpApprovedPOEvent;
